/**
 * Landing-Entry (v2, Saso 2026-09-19: 'lazy loading').
 *
 * Die Marketing-Landing ist eine eigene HTML-Seite (index.html) mit DIESEM
 * schlanken Entry — sie zieht NICHT den App-Shell-Entry (Router, Session-
 * Logik, Error-Reporter, Views) mit. Ein Landing-Besucher laedt nur:
 *   dieses Modul + api.ts + landing.ts (ein Session-Call fuer den
 *   'Zur App'-Link). Der App-Code (main-[hash].js + View-Chunks) geht
 *   erst beim Wechsel in die App uebers Netz — dort gecached (immutable).
 */
import { initLanding } from './pages/landing.js';

void initLanding();
